"use client";
import { WobbleCard } from "../ui/wobble-card";

export function AboutWobbleCard() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 max-w-7xl mx-auto w-full px-4 md:px-8">
      {/* First Card */}
      <WobbleCard
        containerClassName="col-span-1 lg:col-span-2 h-full bg-[#01A9DE] min-h-[500px] lg:min-h-[300px] relative"
      >
        <div className="max-w-xs md:max-w-sm lg:max-w-md">
          <h2 className="text-left text-2xl sm:text-3xl md:text-3xl font-semibold tracking-[-0.015em] text-white">
            Value Blinds - Enhancing Your Home
          </h2>
          <p className="mt-4 text-left text-xl sm:text-lg md:text-lg text-neutral-200">
            Offering premium blinds with quality craftsmanship and affordable pricing.
          </p>
        </div>
        <img
          src="/images/valueblinds-1.jpg"
          width={600}
          height={500}
          alt="Blinds showcase"
          className="hidden sm:block absolute right-1/2 transform translate-x-1/2 sm:right-auto sm:translate-x-0 lg:-right-[40%] grayscale filter -bottom-10 object-contain rounded-2xl max-w-[90%] sm:max-w-none"
        />
      </WobbleCard>

      {/* Second Card */}
      <WobbleCard
        containerClassName="col-span-1 min-h-[300px] bg-[#0274BD]"
      >
        <h2 className="max-w-80 text-left text-2xl sm:text-3xl md:text-3xl font-semibold tracking-[-0.015em] text-white">
          Custom Blinds for Every Home
        </h2>
        <p className="mt-4 max-w-[26rem] text-left text-xl sm:text-lg md:text-lg text-neutral-200">
          Tailor-made solutions for a perfect fit and premium aesthetics.
        </p>
      </WobbleCard>

      {/* Third Card */}
      <WobbleCard
        containerClassName="col-span-1 lg:col-span-3 bg-[#003EA1] min-h-[500px] lg:min-h-[600px] xl:min-h-[300px] relative"
      >
        <div className="max-w-sm md:max-w-lg">
          <h2 className="text-left text-2xl sm:text-3xl md:text-3xl font-semibold tracking-[-0.015em] text-white">
            Transform Your Space with Stylish Window Coverings
          </h2>
          <p className="mt-4 max-w-[26rem] text-left text-xl sm:text-lg md:text-lg text-neutral-200">
            Discover a wide range of blinds designed to enhance privacy and style.
          </p>
        </div>
        <img
          src="/images/valueblinds-2.jpg"
          width={900}
          height={500}
          alt="Blinds collection"
          className="hidden sm:block absolute right-1/2 transform translate-x-1/2 sm:right-auto sm:translate-x-0 lg:-right-[20%] -bottom-10 object-contain rounded-2xl max-w-[90%] sm:max-w-none"
        />
      </WobbleCard>
    </div>
  );
}
